import React, { Component } from "react";
import { TreeItem } from "@mui/x-tree-view";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";

export default class StructureItem extends Component {
  constructor(props) {
    super(props);

    this.state = {
      id: this.props.data.id,
      name: this.props.data.name,
    };
  }

  render() {
    return (
      <TreeItem
        style={{ marginBottom: 10, marginTop: 10 }}
        nodeId={this.props.nodeId}
        label={
          <Card>
            <CardContent>
              <Typography>{this.state.name}</Typography>
            </CardContent>
          </Card>
        }
        {...this.props}
      />
    );
  }
}
